import { getAuthConfig } from '../config/auth';

function resolveApiUrl(): string {
  let apiUrl = getAuthConfig().apiUrl;
  if (import.meta.env.VITE_ENVIRONMENT === 'dev') {
    try {
      const stored = localStorage.getItem('vibe-dev-mode-config');
      if (stored && JSON.parse(stored).apiTarget === 'local') apiUrl = 'http://localhost:8000';
    } catch { /* ignore */ }
  }
  return apiUrl;
}

const EXT_MAP: Record<string, string> = {
  html: 'html', svg: 'svg', png: 'png', gexf: 'gexf', pkl: 'pkl',
};

function slugifyProjectName(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '') || 'project';
}

export async function exportProjectBackup(
  token: string,
  projectId: string,
  projectName: string,
): Promise<void> {
  const apiUrl = resolveApiUrl();
  const response = await fetch(`${apiUrl}/dastarkhan/projects/${projectId}/export-excel`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) throw new Error(`Backup export failed (${response.status})`);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const date = new Date().toISOString().split('T')[0];
  a.download = `${slugifyProjectName(projectName)}_backup_${date}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function exportGraphSubgraph(
  token: string,
  projectId: string,
  format: string,
  nodeIds?: string[],
  edgeIds?: string[],
): Promise<void> {
  const apiUrl = resolveApiUrl();
  const body: Record<string, unknown> = { format, node_ids: nodeIds ?? null };
  if (edgeIds && edgeIds.length > 0) {
    body.edge_ids = edgeIds;
  }
  const response = await fetch(`${apiUrl}/dastarkhan/projects/${projectId}/export`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(`Export failed (${response.status})`);
  const blob = await response.blob();
  const ext = EXT_MAP[format] || format;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `graph.${ext}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
